exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#history-view-controls{flex:0 0 44px;background-color:#fff;border-bottom:1px solid #ddd;width:100%;padding:8px}.history-panel>.controls .title{font-size:120%}.history-panel>.controls .title input{font-size:100%}a.btn{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./galaxy/scripts/components/HistoryView.vue?vue&type=style&index=0&lang=css
// module id = 723
// module chunks = 0